<template>
  <!-- 最新活动主页 -->
  <div>
    <Header class="header"></Header>
    <channel-banner></channel-banner>
    <!-- navigation -->
    <div :class="{fixed: fixedNavigation}">
        <div class="navigation">
          <div :class="{current_nav:index==number}" v-for="(item,index) in activityTypeList" :key="index" @click="choiceNav(index)">
            <span>{{item.name}}</span>
          </div>
        </div>
    </div>
    <!-- main -->
    <div class="main" :class="{fixed_main: fixedNavigation}">
        <div class="mod" :id="'mod'+index" v-for="(item,index) in activityTypeList" :key="index" :class="{ active: index % 2 != 0 }">
            <div class="module">
                <p >{{item.name}}</p>
                <span>{{item.description}}</span>
                <p>一</p>
                <div class="box">
                    <div class="box_con" v-for="(i,d) in item.children" :key="d">
                        <div class="box_title">{{i.name}}</div>
                        <span class="box_description">{{i.description}}</span>
                        <div class="box_logo">nihao</div>
                        <div class="forDetails" @click="enterDetail(i)">了解详情</div>
                    </div>
                </div>
              </div>
        </div>
    </div>
  </div>
</template>
<script>
    import { queryAllPromotionType, queryPromotionByTypeId } from '@/api/channel/latestActivity.js'
    import Header from '../../../components/common/header.vue'
    import ChannelBanner from '../../../components/channel/channelBanner.vue'
    export default {
        components: {
            Header,
            ChannelBanner
        },
        data() {
            return {
                activityTypeList: [],
                number: 0,
                target1: 0,
                target2: 0,
                fixedNavigation: false,
            }
        },
        created() {
            this.getData();
        },
        mounted() {
            //监听页面滚动事件
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            async getData() {
                let res = await queryAllPromotionType();
                for (let index = 0; index < res.data.list.length; index++) {
                    let result = await queryPromotionByTypeId(res.data.list[index].id);
                    res.data.list[index].children = result.data.list;
                }
                this.activityTypeList = res.data.list;
            },
            //选择活动类型
            choiceNav(i) {
                this.number = i;
                // if(i == 0) {
                //     this.animate(window, 438);
                // }
                document.getElementById('mod'+i).scrollIntoView({
                    block: 'start',
                    inline: 'nearest',
                    behavior: 'smooth'
                })
            },
            //滚动事件
            handleScroll() {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // console.log('--------------');
                // console.log(scrollTop);
                this.target1 = document.getElementById('mod'+1).offsetTop - 0 - 74;
                this.target2 = document.getElementById('mod'+2).offsetTop - 0 - 74;
                if ( scrollTop < 437) {
                    this.fixedNavigation = false;
                } else if(scrollTop < this.target1){
                    this.fixedNavigation = true;
                    this.number = 0;
                } else if (scrollTop < this.target2) {
                    this.fixedNavigation = true;
                    this.number = 1;
                } else {
                    this.fixedNavigation = true;
                    this.number = 2;
                }
            },
            //动画函数
            animate(obj, target, callback) {
                clearInterval(obj.timer);
                obj.timer = setInterval(function () {
                    var step = (target - window.pageYOffset) / 10;
                    step = step > 0 ? Math.ceil(step) : Math.floor(step);
                    if (window.pageYOffset == target) {
                        clearInterval(obj.timer);
                        callback && callback();
                    }
                    window.scroll(0, window.pageYOffset + step);
                }, 15);
            },
            //了解详情
            enterDetail(data) {
                this.$router.push({
                    path: '/latestActivity/eventDetail',
                    query: {
                        data: JSON.stringify(data)
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped="scoped">
    .header {
        position: relative;
        top: 0;
        height: 80px;
    }
    /* navigation */
    
    .navigation {
        display: flex;
        justify-content: center;
        height: 74px;
        border-bottom: 1px solid #EFF0F5;
        box-shadow: 0px 0px 12px -2px #ccc;
    }
    
    .navigation div {
        display: block;
        height: 74px;
        padding: 0 30px;
        margin: 0 20px;
        font-size: 16px;
        color: #2A2A2A;
        line-height: 74px;
        text-decoration: none;
    }

    .navigation div:hover {
        cursor: pointer;
    }

    .navigation .current_nav {
        color: #5984EC;
        border-bottom: 1px solid #5984EC;
    }

    .fixed {
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        margin-bottom: 74px;
        background-color: #fff;
    }
    /* main */
    
    .main {
        width: 100%;
    }

    .fixed_main {
        margin-top: 75px;
    }
    
    .mod {
        width: 100%;
    }
    
    .module {
        width: 1300px;
        margin: auto;
        padding: 50px 0;
        text-align: center;
    }
    
    .active {
        background-color: #F9FAFD;
    }
    
    .module p {
        margin: 20px 0;
        font-size: 36px;
        color: #507DF1;
    }
    
    .module span {
        font-size: 16px;
        color: #7F7F7F;
    }
    
    .box {
        overflow: hidden;
    }
    
    .box_con {
        float: left;
        position: relative;
        width: 368px;
        height: 128px;
        margin: 20px 20px 20px 0;
        padding: 20px;
        background: url(../../../assets/channel/zxhd/bg_01.png) no-repeat left bottom;
        border: 1px solid #EFF0F5;
        text-align: left;
        box-shadow: 0px 0px 12px -3px #ccc;
    }
    
    .box_con:hover {
        bottom: 5px;
        border-color: #5984EC;
        transition: all .2s;
        .box_title {
            color: #5984EC;
        }
    }
    
    .box_title {
        padding-bottom: 5px;
        border-bottom: 1px solid #E5E5E5;
        font-size: 16px;
        color: rgb(42, 42, 42);
    }
    
    .box_description {
        font-size: 10px;
        color: rgb(127, 127, 127);
    }
    
    .box_logo {
        position: absolute;
        left: 20px;
        bottom: 20px;
        width: 50px;
        background-color: #E42A36;
        font-size: 8px;
        color: #fff;
        text-align: center;
    }
    
    .forDetails {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 126px;
        height: 38px;
        background-color: rgba(80, 125, 241, 1);
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 38px;
    }
    
    .forDetails:hover {
        cursor: pointer;
        background-color: #6089F3;
    }
</style>